<template>
    <div id="successful">
        <img src="@/assets/success.png" width="100" height="100"/>
        <p v-if="type==1">您的申请我们已收到，我们将会与您联系！</p>
        <p v-if="type==2">取消成功</p>
        <div class="sure" @click="toUrl()">确认</div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            type:''
        }
    },
    mounted(){
         let type = this.$route.query.type;
         this.type = type
    },
    methods:{
        toUrl(){
            this.$router.go(-1)
        }
    }
}
</script>
<style scoped>
#successful{
    padding-top: 2rem;
}
.sure{
        width: 90%;
    color: white;
    background: #4CAF50;
    line-height: 2.5rem;
    border-radius: 5px;
    margin: 0 auto;
    text-align: center;
    margin-top: 3rem;
}
</style>


// WEBPACK FOOTER //
// src/page/successful.vue